import angular from "angular";
import KontaktService from "./KontaktService";
import ListViewCtrl from "../util/ListViewCtrl";
import AresImportCtrl from "./AresImportCtrl";
import KontaktImportListCtrl from "./KontaktImportListCtrl";
import { EditCtrl } from "../Editor";

export default angular
.module("energis.kontakt", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("kontakt-list", {
    url: "/kontakty",
    template: require("./kontakt.list.html"),
    controller: ListViewCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: KontaktService => KontaktService.listSource().wait()
    }
  })
  .state("kontakt-edit", {
    url: "/kontakty/{id:int}/edit",
    template: require("./kontakt.edit.html"),
    controller: EditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, KontaktService) => KontaktService.get($stateParams.id),
      saveHandler: (KontaktService) => (id, item) => KontaktService.save(id, item)
    }
  })
  .state("kontakt-import", {
    url: "/kontakty/import",
    template: require("./kontakt.import.html"),
    controller: KontaktImportListCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: (KontaktService) => KontaktService.importSource().wait(),
    }
  })
  .state("kontakt-ares", {
    url: "/kontakty/import/ares",
    template: require("./kontakt.ares.html"),
    controller: AresImportCtrl,
    controllerAs: "ctrl"
  })
})
.service("KontaktService", KontaktService)
.name;



// WEBPACK FOOTER //
// ./src/Kontakt/index.js